import logoLight from '../../assets/images/Light DP (1).jpg';
import logoDark from '../../assets/images/Dark DP (1).jpg';

interface LogoProps {
  className?: string; 
}

const Logo: React.FC<LogoProps> = ({ className = "w-8 h-8" }) => {
  return (
    <div className={`${className} rounded-2xl overflow-hidden shadow-sm`}>
      <img 
        src={logoLight} 
        alt="ClickCollab" 
        className="w-full h-full object-cover dark:hidden"
      />
      <img 
        src={logoDark} 
        alt="ClickCollab" 
        className="w-full h-full object-cover hidden dark:block"
      />
    </div>
  );
};

export default Logo;
